<template>
  <DialogFull :data="dialogSettings" @close="close">
    <div class="container col-lg-8 col-sm-12">
      <CriminalConvictions @close="close" submitButtonTitle="Save Changes" />
    </div>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import CriminalConvictions from "@/views/profile/QuestionsAndAnswers/steps/CriminalConvictions";

export default {
  components: {
    DialogFull,
    CriminalConvictions
  },
  props: {
    isOpen: Boolean
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Criminal Convictions"
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
